import { createDynamicThunk } from ".";

/**
 * LIST Client
 */
export const fetchClientsThunk = createDynamicThunk({
  typePrefix: "clients/fetchClientsThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT Client
 */
export const submitClientThunk = createDynamicThunk({
  typePrefix: "clients/submitClientThunk",
  endpoint: "/clients",
  method: "POST",
});

/**
 * Fetch Client by Deparmtent
 */
export const fetchClientsByDeptThunk = createDynamicThunk({
  typePrefix: "clients/fetchClientsByDeptThunk",
  endpoint: "/clients/findClientsByDept",
  method: "POST",
});

/**
 * Fetch clients without pagination (for dropdowns)
 */
export const fetchClientsSimpleThunk = createDynamicThunk({
  typePrefix: "clients/fetchClientsSimple",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});
